import { render, staticRenderFns } from "./CustomerDiscription.vue?vue&type=template&id=576b1538&scoped=true&"
import script from "./CustomerDiscription.vue?vue&type=script&lang=js&"
export * from "./CustomerDiscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b1538",
  null
  
)

export default component.exports